import colors from '../colors';
import theme from '../radius';

const filledSnackbarContentBg = colors.palette.info.main;
const defaultTextColor = colors.palette.primary.main;

const snackBarContent = {
  MuiSnackbarContent: {
    styleOverrides: {
      root: {
        '&.MuiSnackbarContent-root': {
          border: 'none',
          borderRadius: theme.radius.sm,
          display: 'flex',
          flex: 'initial',
          overflow: 'hidden',
          backgroundColor: filledSnackbarContentBg,
          marginBottom: '1rem',
          flexDirection: 'column',

          '.MuiSnackbarContent-message': {
            alignItems: 'center',
            color: defaultTextColor,
            display: 'flex',
            flex: 1,
            fontWeight: 'bold',
            lineHeight: '18px',
            paddingRight: '0.5rem',
          },
        },
      },
    },
  },
};

export default snackBarContent;
